// import { LuScreenShare } from "react-icons/lu";
import footer from "../Styles/Footer.module.scss";
import UseToggle from "../Hooks/UseToggle";
import { Col, Container, Form, Row, Table, Offcanvas, Badge, Collapse, ListGroup } from "react-bootstrap";
import { useEffect, useState } from "react";
import { NoDataFoundTable, PageLoader } from "../Components/NoDataFoundTable/NoDataFoundTable";
import { usersOnboardingService } from "../APIServices/usersOnboarding";
// import { LuScreenShare } from "react-icons/lu";
const Footer = () => {
  const currentDate = new Date();
  const year = currentDate.getUTCFullYear();
  const toggels = UseToggle();

  const [loading, setLoading] = useState(false);
  const [openOption, setOpenOption] = useState("");
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [managentList, setManagentList] = useState([]);
  const [designationLists, setDesignationLists] = useState([]);

  const getClientUser = async () => {
    setLoading(true);
    try {
      const data = await usersOnboardingService.getSeparateActiveApprovedUser();
      setUsers(data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  const getManagentList = async () => {
    const data = await usersOnboardingService.getManagentList();
    setManagentList(data || []);
  };

  const getDesignation = async () => {
    const data = await usersOnboardingService.getDesignation();
    setDesignationLists(data || []);
  };

  useEffect(() => {
    getManagentList();
    getDesignation();
    getClientUser();
  }, []);

  return (
    <div className={footer.footer}>
      <Container fluid>
        <Row>
          <Form.Group as={Col} md={12}>
            <div className={footer.innerFooter}>
              <p className="mb-1">
                <i className="fas fa-copyright" /> {year} CopyRight | Galaxbiotech®
              </p>
              <div className="hstack gap-2">
                {/* <LuScreenShare
                  title="Screen Share"
                  className="CP"
                  onClick={toggels.setToggle}
                />  */}
                <p className="m-0">V2.0.0</p>
              </div>
            </div>
          </Form.Group>
        </Row>
      </Container>

      <Offcanvas
        show={!toggels.toggle}
        onHide={toggels.setToggle}
        placement="end"
        style={{ width: 750 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Share screen with co-worker</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {loading ? (
            <PageLoader/>
          ) : users.length === 0 ? (
            <NoDataFoundTable MSG="User list not found!" />
          ) : (
            <Table id="resizable-table" striped className="m-0 custom-table">
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th className="text-center" style={{ width: 45 }}>Sr.</th>
                  <th>User Id</th>
                  <th>User Name</th>
                  <th>Designation</th>
                  <th>Management</th>
                  <th style={{ width: 65 }} className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, index) => (
                  <tr key={index} className={`${userId === user?.userId && "highlighted"}`} onClick={() => setUserId(user?.userId)}>
                    <td className="text-center">{index + 1}</td>
                    <td>{user?.userId}</td>
                    <td>{`${user?.firstName} ${user?.lastName}`}</td>
                    <td>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        disabled
                        className="form-select countryoption w-100 border-0 rounded-0 p-0 px-2 bg-transparent"
                        value={user?.designation_id?._id || ""}
                      >
                        {designationLists.map((data) => (
                          <option key={data._id} value={data._id}>
                            {data.name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        disabled
                        className="form-select countryoption w-100 border-0 rounded-0 p-0 px-2 bg-transparent"
                        value={user?.management?.management_id?._id || ""}
                      >
                        {managentList.map((data) => (
                          <option key={data._id} value={data._id}>
                            {data.name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td className="text-center">
                      <Badge
                        className="br3 CP"
                        title={`Share with ${user?.firstName} ${user?.middleName || ""} ${user?.lastName}`}
                        style={{ fontSize: 10 }}
                        onClick={() => setOpenOption(openOption === user?.userId ? "" : user?.userId)}
                      >
                        Share
                      </Badge>
                      <Collapse in={openOption === user?.userId}>
                        <div className="position-absolute end-0 mt-1" style={{ zIndex: 1000 }}>
                          <ListGroup className="br3 text-start">
                            <ListGroup.Item action title={`Read access to ${user?.firstName} ${user?.middleName || ""} ${user?.lastName}`}>Read Only</ListGroup.Item>
                            <ListGroup.Item action title={`Read + Write (Both) access to ${user?.firstName} ${user?.middleName || ""} ${user?.lastName}`}>Read + Write (Both)</ListGroup.Item>
                          </ListGroup>
                        </div>
                      </Collapse>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Footer;
